module.exports = __webpack_public_path__ + "img/Swirls960x682.e00bf417.jpg";